import fetch from "auth/FetchInterceptor";

const SubscriberSettingsService = {};
const apiRoute = "/subscriber-settings";

SubscriberSettingsService.create = async function (data, showErrorNotification = true) {
  return fetch({
    url: `${apiRoute}/admin/create`,
    method: "POST",
    data,
    showErrorNotification,
  });
};

SubscriberSettingsService.getAll = async function (query = "", showErrorNotification = true) {
  const q = query ? (query.startsWith("?") ? query : `?${query}`) : "";
  return fetch({
    url: `${apiRoute}/admin/getAll${q}`,
    method: "GET",
    showErrorNotification,
  });
};

SubscriberSettingsService.getById = async function (id, showErrorNotification = true) {
  return fetch({
    url: `${apiRoute}/admin/get/${id}`,
    method: "GET",
    showErrorNotification,
  });
};

SubscriberSettingsService.update = async function (id, data, showErrorNotification = true) {
  return fetch({
    url: `${apiRoute}/admin/update/${id}`,
    method: "PATCH",
    data,
    showErrorNotification,
  });
};

SubscriberSettingsService.subscriberUpdate = async function (data, showErrorNotification = true) {
  return fetch({
    url: `${apiRoute}/subscriber/update`,
    method: "PATCH",
    data,
    showErrorNotification,
  });
};

SubscriberSettingsService.subscriberGetById = async function (showErrorNotification = true) {
  return fetch({
    url: `${apiRoute}/subscriber/getById`,
    method: "GET",
    showErrorNotification,
  });
};

SubscriberSettingsService.getPublicSettings = async function (
  showErrorNotification = true
) {
  return fetch({
    url: `${apiRoute}/public/get`,
    method: "GET",
    showErrorNotification,
  });
};

SubscriberSettingsService.delete = async function (id, showErrorNotification = true) {
  return fetch({
    url: `${apiRoute}/${id}`,
    method: "DELETE",
    showErrorNotification,
  });
};

export default SubscriberSettingsService;
